<header class="header-area bg-white border-bottom-radius box-shadow "
    [ngClass]="{ active: isToggled, sticky: isSticky }" [class.component-dark-theme]="themeService.isDark()"
    [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.dark-header]="themeService.isHeaderDark()" [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.card-border-radius]="themeService.isCardBorderRadius()" [class.rtl-enabled]="themeService.isRTLEnabled()">
    <div role="alert" class="alert alert-bg-danger py-2 d-flex align-items-center justify-content-center"
        *ngIf="isActiveSwitchUser">
        <p class="p-0 m-0 text-white w-100 text-center">
            You are currently Viewing
            <b class="text-underline">{{activeSwitchUserDetails?.name}}</b>
        </p>

        <button mat-menu-item class="profile-switch-button w-auto text-white" (click)="backToMainProfile()">
            <i class="ri-arrow-go-back-line"></i>
            Exit
        </button>

    </div>
    <div class="d-md-flex align-items-center justify-content-space-between">
        <div class="header-left-side d-flex align-items-center">
            <div class="burger-menu" (click)="toggle()" [ngClass]="{ active: isToggled }">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </div>
            <form class="search-box position-relative">
                <input type="text" class="input-search d-block"
                    placeholder="Enter CAMS ID, Student Name, Passport No. here..." [(ngModel)]="search"
                    [ngModelOptions]="{ standalone: true }" />
                <button type="submit" [matMenuTriggerFor]="applicant_menu" #applicant_menu_trigger="matMenuTrigger"
                    (click)="
                        searchApplicant(); applicant_menu_trigger.closeMenu()
                    ">
                    <i class="ri-search-line"></i>
                </button>
                <mat-menu class="menu-dropdown search-menu" #applicant_menu="matMenu" xPosition="before">
                    <div class="menu-header align-items-center justify-content-space-between"
                        (click)="$event.stopPropagation()">
                        <ng-container *ngIf="
                                search_applicant_list?.length;
                                else no_result
                            ">
                            <h5>Founds below search result.</h5>
                            <h6>Click to see details</h6>
                        </ng-container>
                        <ng-template #no_result>
                            <h5>No Result Found.</h5>
                        </ng-template>
                    </div>
                    <ul class="menu-body">
                        <li class="position-relative" *ngFor="let applicant of search_applicant_list">
                            <div class="d-flex">
                                <div class="title">
                                    <h5 class="mb-0">{{ applicant?.id }}</h5>
                                    <span class="applicant-name">
                                        {{
                                        applicant?.studentPersonalDetailsRef
                                        ?.firstName
                                        }}&nbsp;
                                        {{
                                        applicant?.studentPersonalDetailsRef
                                        ?.lastName
                                        }}
                                    </span>
                                </div>
                            </div>
                            <a [href]="applicant?.dynamicUrl" target="_blank" class="link-btn"></a>
                        </li>
                    </ul>
                    <div class="menu-footer search--footer" *ngIf="pagination_config.total > 10">
                        <mat-paginator [pageSize]="pagination_config.size" [pageSizeOptions]="[10, 20, 50, 100]"
                            showFirstLastButtons [length]="pagination_config.total" (page)="pagination($event)">
                        </mat-paginator>
                    </div>
                </mat-menu>
            </form>
        </div>
        <ul class="header-right-side d-flex align-items-center mt-0 mb-0">
            <li>
                <!-- <a routerLink="/admin/profile/holiday-list"> -->
                <span class="user_call" (click)="userData()">
                    {{ user_details?.extension }}
                </span>
                <!-- </a> -->
            </li>

            <li>
                <a routerLink="/admin/profile/holiday-list">
                    <button mat-icon-button class="btn p-0 border-none rounded-circle position-relative">
                        <span class="material-symbols-outlined">
                            sentiment_satisfied
                        </span>
                    </button>
                </a>
            </li>
            <li>
                <button mat-icon-button class="btn p-0 border-none rounded-circle position-relative"
                    [matMenuTriggerFor]="agentCommission">
                    <span class="material-symbols-outlined">
                        attach_money
                    </span>
                </button>
                <mat-menu class="commission-menu-dropdown" #agentCommission="matMenu" xPosition="before">
                    <ul class="m-0">
                        <li>
                            <a routerLink="/admin/profile/agent-commission-crizac">
                                Agent Commission Crizac
                            </a>
                        </li>
                        <li>
                            <a routerLink="/admin/profile/agent-commission-ucol">
                                Agent Commission UCOL
                            </a>
                        </li>
                        <li>
                            <a routerLink="/admin/profile/agent-commission-gaspl">
                                Agent Commission GASPL
                            </a>
                        </li>
                    </ul>
                </mat-menu>
            </li>
            <li class="d-none d-lg-block">
                <div class="date-btn main-color fw-semibold position-relative cursor-pointer" routerLink="/admin/event">
                    <i class="flaticon-calendar"></i> {{ formattedDate }}
                </div>
            </li>
            <app-notifications></app-notifications>
            <li>
                <button mat-icon-button [matMenuTriggerFor]="profileMenu"
                    class="profile-btn main-color border-none bg-transparent position-relative">
                    <ng-container *ngIf="user_details?.profilepic; else no_pic">
                        <img src="{{
                                file_path_with_base_url(
                                    user_details?.profilepic
                                )
                            }}" class="rounded-circle" alt="admin" />
                    </ng-container>
                    <ng-template #no_pic>
                        <img src="assets/img/admin.jpg" class="rounded-circle" alt="admin" />
                    </ng-template>
                    <span class="fw-semibold">{{ user_details?.name }}</span>
                    {{ role_name }}
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <ul class="m-0">
                        <ng-container *ngIf="!isActiveSwitchUser">
                            <li *ngIf="
                                permissions_entity.modules.profile
                                    | permissions
                                        : permissions_entity.access.read
                            "
                            (click)="setValue()">
                                <a routerLink="/admin/profile">
                                    <i class="ri-user-3-line"></i> Profile
                                </a>
                            </li>
                            <li *ngIf="
                                permissions_entity.modules.update_password
                                    | permissions
                                        : permissions_entity.access.edit
                            ">
                                <a routerLink="/admin/profile/setting">
                                    <i class="ri-settings-3-line"></i> Change
                                    Password
                                </a>
                            </li>
                        </ng-container>
                        <li *ngIf="showDeligateOption">
                            <app-switch-user-list [exitToMainProfile]="exitToMainProfile"></app-switch-user-list>
                        </li>
                        <li>
                            <a href="javascript:void(0)" (click)="onLogout()">
                                <i class="ri-shut-down-line"></i> Logout
                            </a>
                        </li>
                    </ul>
                </mat-menu>
            </li>
        </ul>
    </div>
</header>